import { render, staticRenderFns } from "./CheckoutConfirmed.vue?vue&type=template&id=373d6c75&"
import script from "./CheckoutConfirmed.vue?vue&type=script&lang=js&"
export * from "./CheckoutConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports